<div class="vid-wrap">
  <div id="vid-player"></div>
</div>